const moment = require("moment");

/** How far before "today" we still put occurrences into the date cache. */
const LOOKBACK_DAYS = 31;

/**
 * Start of the user's local calendar day, encoded like repeating dtstart
 * (UTC midnight of YYYYMMDD). Using `new Date()` here skips "today" once the
 * local clock is past that UTC midnight (common in UTC+ timezones).
 */
function cacheRangeStart(now = new Date()) {
  return moment.utc(moment(now).format("YYYYMMDD"), "YYYYMMDD").toDate();
}

function cacheRangeEnd(now = new Date()) {
  const end = cacheRangeStart(now);
  end.setUTCFullYear(end.getUTCFullYear() + 10);
  return end;
}

function utcDay(date) {
  return moment.utc(moment.utc(date).format("YYYYMMDD"), "YYYYMMDD").toDate();
}

/**
 * Occurrence dates for a rule that should be materialized in the UI.
 * Starts at min(today, dtstart) but never earlier than today - LOOKBACK_DAYS,
 * so a COUNT window that began earlier this week (e.g. Tue rule, today Thu)
 * still includes Wed, without exploding the cache for ancient forever-rules.
 */
function datesForRule(rule, now = new Date()) {
  const todayStart = cacheRangeStart(now);
  const lookback = new Date(todayStart);
  lookback.setUTCDate(lookback.getUTCDate() - LOOKBACK_DAYS);

  let start = todayStart;
  const rawDt = rule && rule.options && rule.options.dtstart;
  if (rawDt) {
    const dtstart = utcDay(rawDt);
    if (dtstart < todayStart) {
      start = dtstart > lookback ? dtstart : lookback;
    }
  }
  return rule.between(start, cacheRangeEnd(now), true);
}

module.exports = {
  LOOKBACK_DAYS,
  cacheRangeStart,
  cacheRangeEnd,
  datesForRule,
};
